export default __webpack_public_path__ + "static/media/prev-icon.73f1b3d6.svg";